import io from 'socket.io-client';
import { BASE_URL } from './ApiConfig';
import { forceAuthExpiry, tryRefreshSession } from './authHttp';

/**
 * Socket.IO client that sends auth cookies and reacts to server auth failures.
 * On `unauthorized`, try cookie refresh + reconnect before clearing the session
 * (access_token is short-lived; a live refresh_token should not force logout).
 */
export function createAppSocket(options = {}) {
  const socket = io(BASE_URL, {
    withCredentials: true,
    transports: ['websocket', 'polling'],
    ...options,
  });

  let recoveringAuth = false;

  socket.on('unauthorized', async () => {
    if (recoveringAuth) return;
    recoveringAuth = true;
    try {
      const refreshed = await tryRefreshSession();
      if (!refreshed) {
        console.warn('Socket unauthorized — refresh failed, clearing session');
        forceAuthExpiry();
        return;
      }
      // Handshake cookies are fixed at connect time; reconnect to send new access_token.
      console.warn('Socket unauthorized — refreshed cookies, reconnecting');
      socket.disconnect();
      socket.connect();
    } catch (err) {
      console.warn('Socket unauthorized — recovery error', err);
      forceAuthExpiry();
    } finally {
      recoveringAuth = false;
    }
  });

  return socket;
}

/** Agent identity comes from the cookie session; only role hint is sent. */
export function emitAgentSetup(socket) {
  if (!socket) return;
  socket.emit('setup', { userType: 'agent' });
}
